const state = {
  intakeId: null,
  token: null,
  currentStep: 1,
  questions: [],
  questionTypes: [],
  stepDescriptions: [],
  wrongAnsweredQuestions: [],
  followUpQuestions: [],
  answers: [],
  totalSteps: 0,
  hasError: false,
  errorMessage: '',
  isLoading: false,
  isComplete: false,
  isMobile: false,
  pullFactorsReceived: false,
  possibleFunctionNames: [],
}

export default state
